"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.requestInterceptor = exports.responseInterceptor = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _AuthService = _interopRequireDefault(require("../AuthService"));

var _tenantHelper = require("../util/tenantHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var responseInterceptor = function responseInterceptor(response) {
  return response.data;
};

exports.responseInterceptor = responseInterceptor;

var requestInterceptor = function requestInterceptor(defaultConfig) {
  var config = defaultConfig;
  config.headers.authorization = "Bearer ".concat(_AuthService["default"].getToken());
  config.headers['X-Tenant'] = (0, _tenantHelper.getTenantFromUrl)();
  return config;
};

exports.requestInterceptor = requestInterceptor;

var HttpService = /*#__PURE__*/function () {
  function HttpService() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$baseURL = _ref.baseURL,
        baseURL = _ref$baseURL === void 0 ? '/api' : _ref$baseURL;

    _classCallCheck(this, HttpService);

    this.baseURL = baseURL;
    this.http = _axios["default"].create({
      baseURL: baseURL,
      headers: {
        'content-type': 'application/json',
        'X-Tenant': (0, _tenantHelper.getTenantFromUrl)(),
        'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        authorization: "Bearer ".concat(_AuthService["default"].getToken())
      }
    });
    this.http.interceptors.request.use(requestInterceptor);
    this.http.interceptors.response.use(responseInterceptor, function (error) {
      return Promise.reject(error.response);
    });
    this.httpFileUpload = _axios["default"].create({
      baseURL: baseURL,
      headers: {
        'content-type': 'multipart/form-data',
        'X-Tenant': (0, _tenantHelper.getTenantFromUrl)(),
        'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        authorization: "Bearer ".concat(_AuthService["default"].getToken())
      }
    });
    this.httpFileUpload.interceptors.request.use(requestInterceptor);
    this.httpFileUpload.interceptors.response.use(responseInterceptor, function (error) {
      return Promise.reject(error.response);
    });
    this.httpFileDownload = _axios["default"].create({
      baseURL: baseURL,
      responseType: 'blob',
      headers: {
        'content-type': 'application/json',
        'X-Tenant': (0, _tenantHelper.getTenantFromUrl)(),
        'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
        authorization: "Bearer ".concat(_AuthService["default"].getToken())
      }
    });
    this.httpFileDownload.interceptors.request.use(requestInterceptor);
    this.httpFileDownload.interceptors.response.use(responseInterceptor, function (error) {
      return Promise.reject(error.response);
    });
  }

  _createClass(HttpService, [{
    key: "get",
    value: function get(url) {
      return this.http.get(encodeURI(url));
    }
  }, {
    key: "getFileDownload",
    value: function getFileDownload(url) {
      return this.httpFileDownload.get(encodeURI(url));
    }
  }, {
    key: "getFileDownloadWithPost",
    value: function getFileDownloadWithPost(url, body) {
      return this.httpFileDownload.post(encodeURI(url), body);
    }
  }, {
    key: "post",
    value: function post(url, body) {
      return this.http.post(encodeURI(url), body);
    }
  }, {
    key: "postFile",
    value: function postFile(url, file) {
      var formData = new FormData();

      if (!(file instanceof FormData)) {
        formData.append('file', file);
      } else {
        formData = file;
      }

      return this.httpFileUpload.post(encodeURI(url), formData);
    }
  }, {
    key: "put",
    value: function put(url, body) {
      return this.http.put(encodeURI(url), body);
    }
  }, {
    key: "patch",
    value: function patch(url, body) {
      return this.http.patch(encodeURI(url), body);
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      return this.http["delete"](encodeURI(url));
    }
  }]);

  return HttpService;
}();

exports["default"] = HttpService;